import actions from "~/shared/actions";

function logAction(state, action) {
	const logEntries = Array.from(state.actions);
	logEntries.push({ type: action.type, data: action.data });

	return { ...state, actions: logEntries };
}

export const defaultState = {
	actions: [],
};

export default function logReducer(state = defaultState, action) {
	switch (action.type) {
		case actions.EMPTY_LOG: {
			return defaultState;
		}
		default:
			return logAction(state, action);
	}
}
